import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';

/* global customElements */
class DataWatchGrid extends BaseComponent {
	
	static get properties() {
		return {			
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		this.admin = false;
		
		var dataWatchGrid = this;
		setTimeout(function(){
			dataWatchGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var dataWatchGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',					
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},
				{
					tag: 'vaadin-button',
					itemid: 'add',
					theme: 'primary',					
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_DATA_WATCHES:WRITE', 'DATA_WATCHES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'edit',					
					disabled: true,
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_DATA_WATCHES:WRITE', 'DATA_WATCHES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'updateStatus',
					'class': 'spacer-toolbar-item',				
					permissions: ['ADMIN_DATA_WATCHES:UPDATE_STATUS', 'DATA_WATCHES:UPDATE_STATUS'],
					children:[
						ElementUtil.makeIcon('vaadin:exchange', ' Toggle Status')
					],
					listeners: {
						click: function() {							
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'test',
					'class': 'spacer-toolbar-item',				
					permissions: ['ADMIN_DATA_WATCHES:EXECUTE', 'DATA_WATCHES:EXECUTE'],
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Check Now')
					],
					listeners: {
						click: function() {							
							actionTest(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_FEEDBACK_MANAGEMENT:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}			
			]
		});	
				
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'name',
					header: 'Name',					
					width: '7em'
				},	
				{						
					path: 'emailAddresses',
					header: 'Email',					
					width: '7em'
				},
				{						
					path: 'checkIntervalMinutes',
					header: 'Check Interval',					
					width: '7em',
					'text-align': 'center'
				},	
				{						
					path: 'reportExceptionsOnly',
					header: 'Report Exception Only',					
					'text-align': 'center',
					width: '7em'
				},	
				{						
					path: 'watchTypeDescription',
					header: 'Watch Type',					
					width: '7em'
				},
				{						
					path: 'runStatus',
					header: 'Run Status',					
					width: '7em',
					'text-align': 'center'
				},
				{						
					path: 'lastRunDts',
					header: 'Run Time',					
					width: '7em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {
						var startDate = TimeUtil.parseDate(rowData.item.lastRunDts);
						var completeDate = TimeUtil.parseDate(rowData.item.lastCompleteDts);
						
						var runtime = '-:-:-';
						if (startDate && completeDate) {
							var millis = completeDate.getTime() - startDate.getTime();
							runtime = TimeUtil.milliToDisplay(millis);
						} else if (startDate) {
							var millis = (new Date()).getTime() - startDate.getTime();
							runtime = TimeUtil.milliToDisplay(millis);
						}						
						root.innerHTML = runtime;						
					}
				},
				{						
					path: 'createUser',
					header: 'Owner User',					
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0 && !grid.selectedItems[0].coreModule) {						
						ElementUtil.query(toolbar, 'test').disabled = false; 
						ElementUtil.query(toolbar, 'updateStatus').disabled = false;
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'test').disabled = true;
						ElementUtil.query(toolbar, 'updateStatus').disabled = true;
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					dataWatchGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value						
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						dataWatchGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					DataManagementService.getDatawatchService().getDatawatches(dataWatchGrid.currentFilter)
					.then(function(records){
						successHandler(records);
					});
									
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, dataWatchGrid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				DataManagementService.getDatawatchService().exportDatawatches(exportFilter);
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		dataWatchGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		
		
		var actionUpdateStatus = function(record) {
			var loadMask = grid.showLoading('Updating...');	
			if (record.activeStatus === 'A') {
				DataManagementService.getDatawatchService().inactivateDatawatch(record.watchId).then(function(){
					loadMask.remove();				
					actionRefresh();
				}).catch(function(){
					actionRefresh();
				});	
			} else {
				DataManagementService.getDatawatchService().activateDatawatch(record.watchId).then(function(){
					loadMask.remove();				
					actionRefresh();
				}).catch(function(){
					actionRefresh();
				});
			}
		};
		
		var actionDelete = function(record) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete watch: ' + record.name + '?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting message...');													
							
							DataManagementService.getDatawatchService().deleteDatawatch(record.watchId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted: ' + record.name, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};
		
		var actionTest = function(record) {
			var testWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Test Results',
				icon: 'vaadin:modal-list',
				width: .75,
				height: .75,
				listeners: {
					ready: function () {
						testWin.show();
						
						var output = ElementUtil.create({
							tag: 'div',
							style: 'width: 100%; padding: 10px;'
						});
												
						testWin.addToContentElement(output);
						
						var loadMask = testWin.showLoading();
						DataManagementService.getDatawatchService().getDatawatchTest(record.watchId).then(function(results){
							loadMask.remove();
							var resultText = '<h2>'+ record.name + '</h2>';
							results.forEach(function(result){
								if (result.passed) {
									resultText += 'Passed: <span style="color: green;">' + result.passed + '</span><br>';
								}
								resultText += result.message + '<br>';
							});
							output.innerHTML = resultText;
						}).catch(function(){
							loadMask.remove();
							output.innerHTML = 'Failed running test. Check watch and connection.';
							
						});
						
					}
				}
			});
		};
		
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: (record ? 'Edit' : 'Add'),
				icon: 'vaadin:edit',
				width: .75,
				height: .75,
				listeners: {
					ready: function () {
						addEditWin.show();
						
						var watchItems = [];
						var watchGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},
							children: [
								{
									path: 'carrierId',
									header: 'Carrier Id',
									width: '7em'
								},
								{
									path: 'configName',
									header: 'Integration Name',
									width: '7em',
									renderer: function(root, column, rowData) {
										if (rowData.item.configName) {
											root.innerHTML = rowData.item.configName;
										} else {
											root.innerHTML = '(Not Available)';
										}
									}
								},
								{
									path: 'configId',
									header: 'Integration Config Id',
									width: '7em'
								},
								{
									path: 'minDataAgeMinutes',
									header: 'Min Data Age',
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									watchGrid.selectedItems = item ? [item] : [];
									if (watchGrid.selectedItems.length > 0) {
										ElementUtil.query(formPanel, 'editWatchItem').disabled = false;
										ElementUtil.query(formPanel, 'removeWatchItem').disabled = false;
									} else {
										ElementUtil.query(formPanel, 'editWatchItem').disabled = true;
										ElementUtil.query(formPanel, 'removeWatchItem').disabled = true;
									}
								}
							}
						});
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',									
									children: [
										{
											tag: 'vaadin-text-field',
											label: 'Name',
											name: 'name',
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Email Addresses',
											name: 'emailAddresses',
											required: true,
											maxlength: 255,
											'helper-text': 'comma-separated'
										},
										{
											tag: 'vaadin-number-field',
											itemId: 'chkInterval',
											label: 'Check Interval (Minutes)',
											name: 'checkIntervalMinutes',											
											value: 1440,
											min: 15,
											max: 43200											
										},
										{
											tag: 'vaadin-checkbox',
											itemId: 'complete',
											label: 'Check On Completion',
											name: 'checkOnCompletion',
											listeners: {
												change: function() {
													var checkBox = ElementUtil.query(formPanel, 'complete');
													if (checkBox.checked) {
														ElementUtil.query(formPanel, 'chkInterval').readonly = true;
													} else {
														ElementUtil.query(formPanel, 'chkInterval').readonly = false;
													}
												}
											}
										},																				
										{
											tag: 'vaadin-combo-box',
											itemId: 'watchType',
											name: 'watchType',										
											label: 'Watch Type',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('DataWatchType').then(function (data) {
													combo.items = data;
												});												
											},
											placeHolder: 'Select',
											'helper-text': 'select to add watch item',
											listeners: {
												change: function() {
													var selectedWatchType = ElementUtil.query(formPanel, 'watchType').value;																										
													if (selectedWatchType) {																
														ElementUtil.query(formPanel, 'addWatchItem').disabled = false;
													} else {
														ElementUtil.query(formPanel, 'addWatchItem').disabled = true;
													}
												}
											}
										},
										{
											tag: 'vaadin-checkbox',
											label: 'Report Exception Only',
											name: 'reportExceptionsOnly'
										}	
									]
								},
								{
									tag: 'vaadin-form-layout',
									itemId: 'propertiesLayout',
									children: [
										{
											tag: 'dl-section-title',
											title: 'Watch Items',
											colspan: 2,
											style: 'margin-top: 20px;'
										},
										{
											tag: 'div',
											style: 'height: 250px;',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [
																{
																	tag: 'vaadin-button',
																	itemId: 'addWatchItem',
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',																	
																	disabled: true,
																	children: [
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function () {
																			actionAddEditWatchItem();
																		}
																	}
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'editWatchItem',
																	'class': 'spacer-toolbar-item',
																	disabled: true,
																	children: [
																		ElementUtil.makeIcon('vaadin:edit', ' Edit')
																	],
																	listeners: {
																		click: function () {
																			actionAddEditWatchItem(watchGrid.selectedItems[0]);
																		}
																	}
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'removeWatchItem',
																	theme: 'error primary',
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',
																	disabled: true,
																	children: [
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function () {
																			actionRemoveWatch(watchGrid.selectedItems[0]);
																		}
																	}
																}
															]
														},
														watchGrid
													]
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function () {

															//must have at least 1 item
															if (watchItems.length === 0) {
																window.DL.MessageUtil.showOkMessage('Must have at least 1 item defined');
															} else {
																formPanel.submitForm({
																	preSubmit: function (data) {
																		data.watchItems = watchItems;
																		return data;
																	},
																	actualCall: function (data) {
																		if (record) {
																			data.watchId = record.watchId;
																		}
																		return DataManagementService.getDatawatchService().saveDatawatch(data, (record ? true : false));
																	},
																	success: function (data, responseData) {
																		window.DL.MessageUtil.showToast('Success', 'Saved Data Watch', {
																			theme: 'success',
																			position: 'top-stretch'
																		});
																		actionRefresh();
																		addEditWin.close();
																	}
																});
															}

														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});												
						addEditWin.addToContentElement(formPanel);
							
						var actionRefreshItems = function() {
							watchGrid.activeItem = null;
							watchGrid.items = watchItems.slice(0);
						};					
						
						if (record) {
							formPanel.load(record);
							
							ElementUtil.query(formPanel, 'watchType').readonly = true;							
							
							watchItems = record.watchItemViews;
							actionRefreshItems();
							
							const changeEvent = new Event('change');							
							ElementUtil.query(formPanel, 'complete').dispatchEvent(changeEvent);
							
						}
						
						var actionAddEditWatchItem = function(watchItem) {
							
							var addEditItemWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: (record ? 'Edit' : 'Add'),
								icon: 'vaadin:edit',
								width: 600,
								height: 325,
								listeners: {
									ready: function () {
										addEditItemWin.show();
										
										var watchType = ElementUtil.query(formPanel, 'watchType').value;
										watchType = watchType || 'FUELTAX_FEED';
										
										var itemFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',									
													children: [														
														{
															tag: 'vaadin-number-field',
															itemId: 'carrierId',
															label: 'Carrier Id',
															name: 'carrierId'
														},
														{
															tag: 'vaadin-text-field',
															itemId: 'configId',
															label: 'Config Id',
															name: 'configId'															
														},
														{
															tag: 'vaadin-text-field',
															label: 'Min Data Age (Minutes)',
															name: 'minDataAgeMinutes',
															required: true,
															value: 1440,
															min: 5,
															max: 43200											
														},
														{
															tag: 'div',
															colspan: 2,
															children: [
																{
																	tag: 'vaadin-button',
																	children:[
																		ElementUtil.makeIcon('vaadin:arrow-circle-right-o', ' Select Data Feed')
																	],
																	listeners: {
																		click: function () {
																			actionSelectConfig(watchType);
																		}
																	}
																}
															]
														},													
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		(watchItem ? ElementUtil.makeIcon('vaadin:arrow-up', ' Update') : ElementUtil.makeIcon('vaadin:plus', ' Add'))
																	],
																	listeners: {
																		click: function () {

																			if (itemFormPanel.isValid()){
																				var data = itemFormPanel.getData();
																				data.configName = itemFormPanel.configName;
																				if (watchItem) {
																					watchItem.configId = data.configId;
																					watchItem.carrierId = data.carrierId;
																					watchItem.minDataAgeMinutes = data.minDataAgeMinutes;
																					watchItem.configName = data.configName;
																				} else {
																					watchItems.push(data);
																				}
																				actionRefreshItems();
																				addEditItemWin.close();
																			}

																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {																			
																			addEditItemWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});	
										addEditItemWin.addToContentElement(itemFormPanel);																				
										
										if (watchType === 'FUELTAX_FEED') {
											ElementUtil.query(itemFormPanel, 'configId').required = true;
											ElementUtil.query(itemFormPanel, 'carrierId').classList.add('hide');
										} 
										
										if (watchItem) {
											itemFormPanel.load(watchItem); 
										}
										
										var actionSelectConfig = function() {
											var integrationSelectWin = ElementUtil.create({
												tag: 'dl-dialog',
												title: 'Select Integration',
												icon: 'vaadin:edit',
												width: .70,
												height: .70,
												listeners: {
													ready: function () {
														integrationSelectWin.show();
													
														var selectTools = ElementUtil.create({
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															'class': (dataWatchGrid.admin ? '' : 'hide'),
															children: [
																{
																	tag: 'vaadin-combo-box',
																	itemId: 'companyId',
																	name: 'companyId',
																	label: 'Company',
																	style: 'width: 300px;',
																	'item-value-path': 'code',
																	'item-label-path': 'description',																	
																	postinit: function (combo) {
																		Service.getCompanyService().getCompaniesLookup().then(function (data) {
																			combo.items = data;
																		});
																	},
																	placeHolder: 'Select',
																	listeners: {
																		change: function () {
																			actionRefreshSelect();
																		}
																	}
																}
															]
														});

														var selectGrid = ElementUtil.create({
															tag: 'vaadin-grid',
															theme: 'row-stripes column-borders',
															'column-reordering-allowed': '',
															style: 'height: 100%;',
															slot: 'primary',
															defaults: {
																tag: 'vaadin-grid-sort-column',
																resizable: true
															},
															children: [
																{
																	path: 'configId',
																	header: 'Config Id',
																	width: '7em'
																},
																{
																	path: 'carrierId',
																	header: 'Carrier Id',
																	width: '7em'
																},
																{
																	path: 'tranmissionType',
																	header: 'Tranmission Type',
																	width: '7em'
																},
																{
																	path: 'companyName',
																	header: 'Company Name',
																	width: '7em'
																}
															],
															listeners: {
																'active-item-changed': function (event) {
																	const item = event.detail.value;
																	selectGrid.selectedItems = item ? [item] : [];																	
																}
															}
														});

														var pagingToolbarSelect = ElementUtil.create({
															tag: 'dl-paging-toolbar',
															slot: 'footer',
															pageSize: 50,
															postinit: function (element) {
																element.grid = grid;
																element.loader = function (backingGrid, pageNumber, pagingToolbar) {
																	var pageRange = pagingToolbarSelect.pullRange();
																	var loadMask = selectGrid.showLoading();
																	
																	var module = 'SECURE_FUEL';
																	if (watchType === 'FUELTAX_FEED') {
																		module = 'FUELTAX';
																	}
																	
																	selectGrid.currentFilter = {
																		offset: pageRange.offset,
																		max: pageRange.max,
																		sortField: backingGrid.currentSortField,
																		sortOrder: backingGrid.currentSortDirection,
																		module: module
																	};
																	
																	var selectedCompany = ElementUtil.query(selectTools, 'companyId').value;
																	if (selectedCompany) {
																		selectGrid.currentFilter.companyId = selectedCompany;
																	}

																	var successHandler = function (records) {
																		loadMask.remove();
																		selectGrid.activeItem = null;
																		selectGrid.items = records.data;

																		selectGrid.fullDataSet = records.data;
																		pagingToolbarSelect.totalRecords = records.totalNumber;
																		pagingToolbarSelect.updatePager();
																	};

																	DataManagementService.getDatawatchService().getIntegrationConfigs(selectGrid.currentFilter)
																	.then(function (records) {
																		successHandler(records);
																	});

																};
															},
															listeners: {
																ready: function () {
																	pagingToolbarSelect.loadCurrentPage();
																}
															}

														});		

														var selectBottomBar = ElementUtil.create({
															tag: 'dl-toolbar',
															slot: 'footer',
															theme: 'spacing',
															children: [
																{
																	tag: 'div',
																	style: 'text-align: center;',
																	defaults: {
																		tag: 'vaadin-button'
																	},
																	children: [
																		{
																			theme: 'primary',
																			itemId: 'selectBtn',
																			children: [
																				ElementUtil.makeIcon('vaadin:check', ' Select')
																			],
																			listeners: {
																				click: function () {
																					var selectedConfig = selectGrid.selectedItems[0];
																					
																					var data = itemFormPanel.getData();
																					data.configId = selectedConfig.configId;
																					data.carrierId = selectedConfig.carrierId;
																					itemFormPanel.configName = selectedConfig.configName;
																					itemFormPanel.load(data);
																					
																					integrationSelectWin.close();
																				}
																			}
																		},
																		{
																			theme: 'tertiary',
																			innerHTML: 'Cancel',
																			style: 'margin-left: 10px;',
																			listeners: {
																				click: function () {																			
																					integrationSelectWin.close();
																				}
																			}
																		}
																	]
																}
															]
														});
														
														var bottomBarContainer = ElementUtil.create({
															tag: 'div',
															slot: 'footer',
															children: [
																pagingToolbarSelect,
																{
																	tag: 'hr'
																},
																selectBottomBar
															]
														});
														
														var layout = ElementUtil.create({
															tag: 'dl-flex-layout',
															children: [
																selectTools,
																selectGrid,
																bottomBarContainer
															]
														});													
														integrationSelectWin.addToContentElement(layout);	
																						
														var actionRefreshSelect = function() {
															pagingToolbarSelect.loadPage(1);			
														};
														
													}
												}
											});
										};
										
									}
								}
							});
						};
						
						var actionRemoveWatch = function(watchItem) {
							var newItems = [];
							watchItems.forEach(function(item){
								if (item.carrierId !== watchItem.carrierId && item.carrierId !== watchItem.configId) {
									newItems.push(item);
								}
							});
							watchItems = newItems;							
							actionRefreshItems();
						};
						
					}
				}
			});
		};

	}
	
};
customElements.define('dl-datawatch-grid', DataWatchGrid);